import ServiceType from "./ServiceType";

export default ServiceType;